var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconConfiguracio = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "14px",
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Configuraci\xF3") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Inici/Menu-Obert",
  transform: "translate(-31.000000, -401.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-Lateral",
  transform: "translate(0.000000, 83.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Configuraci\\xF3",
  transform: "translate(31.000000, 314.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.0015895,13.45 C5.61268959,13.45 4.4828591,12.351 4.4828591,11 C4.4828591,9.649 5.61268959,8.55 7.0015895,8.55 C8.3904894,8.55 9.52031989,9.649 9.52031989,11 C9.52031989,12.351 8.3904894,13.45 7.0015895,13.45 L7.0015895,13.45 Z M12.3484943,11.686 C12.3772798,11.462 12.3988689,11.238 12.3988689,11 C12.3988689,10.762 12.3772798,10.538 12.3484943,10.314 L13.8669289,9.159 C14.00366,9.054 14.0396419,8.865 13.9532854,8.711 L12.5140109,6.289 C12.4276544,6.135 12.2333523,6.079 12.0750321,6.135 L10.2831354,6.835 C9.90892401,6.555 9.50592714,6.324 9.06694842,6.149 L8.79348626,4.294 C8.77189714,4.126 8.62077332,4 8.44086401,4 L5.56231498,4 C5.38240567,4 5.23128185,4.126 5.20969273,4.294 L4.93623057,6.149 C4.49725185,6.324 4.09425498,6.562 3.72004361,6.835 L1.92814684,6.135 C1.76263027,6.072 1.57552459,6.135 1.48916812,6.289 L0.0498936052,8.711 C-0.0436592381,8.865 -0.000481002712,9.054 0.136250076,9.159 L1.65468469,10.314 C1.6258992,10.538 1.60431008,10.769 1.60431008,11 C1.60431008,11.231 1.6258992,11.462 1.65468469,11.686 L0.136250076,12.841 C-0.000481002712,12.946 -0.0364628655,13.135 0.0498936052,13.289 L1.48916812,15.7103 C1.57552459,15.865 1.76982665,15.921 1.92814684,15.865 L3.72004361,15.165 C4.09425498,15.445 4.49725185,15.676 4.93623057,15.851 L5.20969273,17.706 C5.23128185,17.8733 5.38240567,18 5.56231498,18 L8.44086401,18 C8.62077332,18 8.77189714,17.8733 8.79348626,17.706 L9.06694842,15.851 C9.50592714,15.676 9.90892401,15.438 10.2831354,15.165 L12.0750321,15.865 C12.2405487,15.928 12.4276544,15.865 12.5140109,15.7103 L13.9532854,13.289 C14.0396419,13.135 14.00366,12.946 13.8669289,12.841 L12.3484943,11.686 Z",
  id: "Icon-configuracio"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconConfiguracio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_configuracio.14c3b7607cbfc49fe09eaeef3b73f2c9.svg";